import axios from 'axios';

export const allStoneSettingApi = async (destStoreId, config) => {
    return await axios.get(`${process.env.REACT_APP_STONE_SHARE_URL}/get/settings/?destination_store_id=${destStoreId}`, config);
};

export const addStoneSettingApi = async (reqData, config) => {
    return await axios.post(`${process.env.REACT_APP_STONE_SHARE_URL}/post/settings/`, reqData, config);
};
